window.addEventListener("DOMContentLoaded", () => {

  const carousel = document.querySelector(".product-carousel")

  if (carousel.dataset.productId != 7401235710127) {

    const carouselItems = document.querySelectorAll(
      "#pdp-carousel-indicators li"
    );
    const dropdownText = document.querySelector(
      "#product-form-sampler-dropdown button span"
    );
    const dropdownOptions = document.querySelectorAll(
      "#product-form-sampler-dropdown ul input"
    );

    carouselItems.forEach((item) => {
      item.firstElementChild.addEventListener("click", () => {
        dropdownOptions.forEach((option) => {
          if (
            Number(item.firstElementChild.dataset.bsSlideTo) + 2 ==
            option.dataset.variantMediaPosition
          ) {
            dropdownText.textContent = option.dataset.variantTitle;
            option.checked = true;
          }
        });
      });
    });
  }

});
